import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../productPageContext'

import { ProductBuyBoxCom } from './ProductBuyBoxCom'
import { ProductBuyBoxRebrushed } from './ProductBuyBoxRebrushed'
import { ProductBuyBoxRxCh } from './ProductBuyBoxRxCh'

export const ProductBuyBox: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const { product } = useProductPageContext()

  if (tenant === TENANT.COM) {
    return <ProductBuyBoxCom />
  }

  const isRxProduct = productAccessorIsPrescriptionProduct(product)

  if (isRxProduct && tenant === TENANT.CH) {
    return <ProductBuyBoxRxCh />
  }

  return <ProductBuyBoxRebrushed />
}
